import * as React from 'react';
import Grid from '@mui/material/Grid';
import Day from './Day';
import { DayItem } from '../../../interfaces';

type Props = {
  dayItems: DayItem[];
  selectedMonth: Date;
  selectedDay?: Date;
  setSelectedDay: React.Dispatch<React.SetStateAction<Date>>;
  setDayIsSelected: React.Dispatch<React.SetStateAction<boolean>>;
  disableUnavailable?: boolean;
};

export default function DaysRow({
  dayItems,
  selectedMonth,
  selectedDay,
  setSelectedDay,
  setDayIsSelected,
  disableUnavailable,
}: Props) {
  return (
    <div className="calendar-row">
      <Grid container spacing={0} columns={7}>
        {dayItems.map(dayItem => (
          <Day
            day={dayItem}
            selectedMonth={selectedMonth}
            selectedDay={selectedDay}
            setSelectedDay={setSelectedDay}
            setDayIsSelected={setDayIsSelected}
            disableUnavailable={disableUnavailable}
            key={dayItem.date}
          />
        ))}
      </Grid>
    </div>
  );
}
